<app-header [forceLightBackground]="true"></app-header>
<div class="delegate-page">
  <div class="delegate-page--layout">
    <app-consumer-sidebar class="delegate-page--sidebar"></app-consumer-sidebar>
    <div class="delegate-page--content">
      <app-page-header></app-page-header>
      
      <div class="delegate-container">
        <app-delegate></app-delegate>
      </div>
    </div>
  </div>
</div>



